var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('single-device',{attrs:{"device":_vm.singleDevice,"on-form-submitted":_vm.formSubmitted,"loading":_vm.loadingDevices,"settings":_vm.settings}})}
var staticRenderFns = []

export { render, staticRenderFns }